import Home from "@/view/home/home.vue";
export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/view/login/login.vue")
  },
  {
    path: "/",
    name: "home",
    component: Home,
    redirect: "/ExpertDatabase",
    children: [
      // {
      //   path: "Expertreview", //专家审核
      //   name: "Expertreview",
      //   //redirect: "/home/Expertreview",
      //   component: resolve =>
      //     require(["@/view/Expertreview/Expertreview.vue"], resolve)
      // },
      {
        path: "ExpertDatabase", //专家库
        //name: "ExpertDatabase",
        component: resolve => require(["@/view/view.vue"], resolve),
        children: [
          {
            path: "",
            component: resolve =>
              require(["@/view/ExpertDatabase/ExpertDatabase.vue"], resolve)
          },
          {
            path: "Addexperts", //添加专家
            name: "Addexperts",
            component: resolve =>
              require(["@/view/Addexperts/Addexperts.vue"], resolve)
          }
        ]
      },
      {
        path: "testmanagement", //题库管理
        //name: "testmanagement",
        component: resolve => require(["@/view/view.vue"], resolve),
        children: [
          {
            path: "",
            component: resolve =>
              require(["@/view/testmanagement/testmanagement.vue"], resolve)
          },
          {
            path: "testmanagementdetails", //题库管理详情
            name: "testmanagementdetails",
            component: resolve =>
              require([
                "@/view/testmanagement/testmanagementdetails.vue"
              ], resolve)
          }
        ]
      },

      {
        path: "taskmanagement", //任务管理
        //name: "taskmanagement",
        component: resolve => require(["@/view/view.vue"], resolve),
        children: [
          {
            path: "",
            component: resolve =>
              require(["@/view/taskmanagement/taskmanagement.vue"], resolve)
          },
          {
            path: "Addtasks", //添加任务
            name: "Addtasks",
            component: resolve =>
              require(["@/view/taskmanagement/Addtasks.vue"], resolve)
          },
          {
            path: "TaskExperts",
            name: "TaskExperts",
            component: resolve =>
              require(["@/view/taskmanagement/TaskExperts.vue"], resolve)
          },
          {
            path: "Taskdetails", //任务详情
            name: "Taskdetails",
            component: resolve => require(["@/view/view.vue"], resolve),
            props: route => ({ query: route.query.id }),
            children: [
              {
                path: "",
                component: resolve =>
                  require(["@/view/taskmanagement/Taskdetails.vue"], resolve)
              },
              {
                path: "Allocatingtask", //分配任务-
                name: "Allocatingtask",
                component: resolve =>
                  require(["@/view/taskmanagement/Allocatingtask.vue"], resolve),
                props: { newsletterPopup: false }
              },
              {
                path: "Taskdetailpage", //已分配的任务详情页-
                name: "Taskdetailpage",
                component: resolve =>
                  require(["@/view/taskmanagement/Taskdetailpage.vue"], resolve),
                  props: { newsletterPopup: false } 
              },
              {
                path: "AllocationReviewTask", //已分配的任务详情页-
                name: "AllocationReviewTask",
                component: resolve =>
                  require(["@/view/taskmanagement/AllocationReviewTask.vue"], resolve),
                  props: { newsletterPopup: false } 
              }
              //Taskdetailpage
            ]
          }
        ]
      },

      {
        path: "Mytasks", //我的任务--出题专家
        //name: "Mytasks",
        component: resolve => require(["@/view/view.vue"], resolve),
        children: [
          {
            path: "",
            component: resolve =>
              require(["@/view/Mytasks/Mytasks.vue"], resolve)
          },
          {
            path: "Onlineproposition", //在线命题
            //name: "Onlineproposition",
            component: resolve => require(["@/view/view.vue"], resolve),
            props: route => ({ query: route.query.id }),
            children: [
              {
                path: "",
                component: resolve =>
                  require([
                    "@/view/Onlineproposition/Onlineproposition.vue"
                  ], resolve)
              },
              {
                path: "Setquestion", //出题
                name: "Setquestion",
                component: resolve =>
                  require(["@/view/Onlineproposition/Setquestion.vue"], resolve)
              },
              {
                path:'titledetails',//题目详情
                name:"titledetails",
                component: resolve =>
                  require(["@/view/Onlineproposition/titledetails.vue"], resolve)
              },
              {
                path: "Looksubject", //查看
                name: "Looksubject",
                component: resolve =>
                  require(["@/view/Onlineproposition/Looksubject.vue"], resolve)
              }
            ]
          }
        ]
      },
      {
        path: "Trytoreview", //审核状态
        //name: "Trytoreview",
        component: resolve => require(["@/view/view.vue"], resolve),
        children: [
          {
            path: "",
            component: resolve =>
              require(["@/view/Trytoreview/Trytoreview"], resolve)
          },
          {
            path: "Reviewdetails", //审核详情
            name: "Reviewdetails",
            component: resolve =>
              require(["@/view/Trytoreview/Reviewdetails"], resolve)
          }
        ]
      },
      {
        path: "Mytasks_trial", //我的任务--初审专家
        //name: "Mytasks_trial",
        component: resolve => require(["@/view/view.vue"], resolve),
        children: [
          {
            path: "",
            //location===/#/two
            component: resolve =>
              require(["@/view/Mytasks/Mytasks_trial.vue"], resolve)
          },
          {
            path: "Mytasks_trial_chapters", //审核详情
            name: "Mytasks_trial_chapters",
            component: resolve =>
              require(["@/view/Mytasks/Mytasks_trial_chapters"], resolve)
          },
          {
            path: "Reviewdetails", //审核详情
            name: "Reviewdetails",
            component: resolve =>
              require(["@/view/Trytoreview/Reviewdetails"], resolve)
          },
          {
            path: "Subjectreview", //试题审核
            name: "Subjectreview",
            component: resolve =>
              require(["@/view/Subjectreview/Subjectreview.vue"], resolve)
          }
        ]
      },

      {
        path: "Viewaudit", //查看审核
        name: "Viewaudit",
        component: resolve =>
          require(["@/view/Subjectreview/Viewaudit.vue"], resolve)
      },
      {
        path: "Mytasks_review",
        // name: "Mytasks_review",
        component: resolve => require(["@/view/view.vue"], resolve),
        children: [
          {
            path: "",
            //location===/#/two
            component: resolve =>
              require(["@/view/Mytasks/Mytasks_review.vue"], resolve)
          },
          {
            path: "Mytasks_review_chapters", //审核详情
            name: "Mytasks_review_chapters",
            component: resolve =>
              require(["@/view/Mytasks/Mytasks_review_chapters"], resolve)
          },
          {
            path: "Reviewdetails", //审核详情
            name: "Reviewdetails",
            component: resolve =>
              require(["@/view/Trytoreview/Reviewdetails"], resolve)
          },
          {
            path: "QuestionReview", //试题审核
            name: "QuestionReview",
            component: resolve =>
              require(["@/view/QuestionReview/QuestionReview.vue"], resolve)
          }
        ]
      },
      {
        path: "structureManage", //细目表管理
        name: "structureManage",
        component: resolve =>
          require(["@/view/Structure/StructureManage.vue"], resolve)
      },
      {
        path: "structureDetail", //细目表详情
        name: "structureDetail",
        component: resolve =>
          require(["@/view/Structure/structureDetail.vue"], resolve)
      },
      {
        path: "ProvinceQuestions", //省试题管理
        name: "ProvinceQuestions",
        component: resolve =>
          require(["@/view/Province/ProvinceQuestions.vue"], resolve)
      },
      {
        path: "ProvinceStructureManage", //省细目表管理
        name: "ProvinceStructureManage",
        component: resolve =>
          require(["@/view/Province/ProvinceStructureManage.vue"], resolve)
      },
      {
        path: "ProvinceUser", //省账号管理
        name: "ProvinceUser",
        component: resolve =>
          require(["@/view/Province/ProvinceUser.vue"], resolve)
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/router.js